import { errorMessages } from '../message/errorMessages';

export class Validator
{
  /**
   * コンストラクタ
   * @param { HTMLElement } element
   */
  constructor( element ) {
    this.target          = element;
    this.value           = this.target.value;
    this.attributeNames  = this.target.getAttributeNames();
    this.className       = '';
    this.errorCount      = 0;
    this.errorCode       = '';
    this.errorMessage    = '';
    this.parentItem      = this.target.closest( '.p-form-item, .js-form-item' ) || false;

    if ( element.classList.contains( 'c-input' ) ) {
      this.className = 'c-input';
    } else if ( element.classList.contains( 'c-select' ) ) {
      this.className = 'c-select';
    } else if ( element.classList.contains( 'c-textarea' ) ) {
      this.className = 'c-textarea';
    }
  }

  /**
   * バリデーションの種類（属性名）
   * @type { string[] }
   */
  validationAttributes = [
    'minlength', // 最小文字数
    'maxlength', // 最大文字数
    'data-min-num', // 最小値
    'data-max-num', // 最大値
    'data-required', // 必須
    'data-full-pitch', // 半角
    'data-full-pitch-kana', // 半角カナ
    'data-single-byte-num', // 半角数字
    'data-single-byte-alphanum', // 半角英数字
    'data-single-byte-markalphanum', // 半角英数字記号
    'data-minority-digit', // 少数桁数
    'data-email', // メールアドレス
    'data-email-confirm', // メールアドレス(再確認)
    'data-tel', // 電話番号
    'data-password', // パスワード
    'data-password-confirm', // パスワード(再確認)
    'data-date', // 日付
    'data-regex-validation', // 正規表現精査
  ];

  /**
   * 親要素の.p-form-item を取得する
   */
  getParentItem = () =>
  {
    return this.parentItem;
  }

  /**
   * エラー設定初期化
   * @returns { void }
   */
  initError = () =>
  {
    this.errorCount = 0;
    this.setErrorMessage();
  }

  /**
   * 入力された値を value へ代入
   * @param { string } content
   * @returns { void }
   */
  setValue = ( content ) =>
  {
    this.value = content;
  }

  /**
   * 最終エラーメッセージを設定する
   * @param { string | undefined } errorCode
   */
  setErrorMessage = ( errorCode, value1, value2 ) =>
  {
    this.errorCode    = errorCode || '不明なエラーコード';
    this.errorMessage = errorMessages[ errorCode ] || '不明なエラー';

    // 置換
    this.errorMessage = this.errorMessage.replace( '##', value1 );
    this.errorMessage = this.errorMessage.replace( '**', value2 );
  }

  /**
   * 最終エラーメッセージを取得する
   * @returns { string }
   */
  getErrorMessage = () =>
  {
    return this.errorMessage;
  }

  /**
   * エラーの数を加算
   * @returns { void }
   */
  addErrorCount = () =>
  {
    this.errorCount++;
  }

  /**
   * バリデーション結果の反映（ --error クラスの 追加、削除 ）
   * @returns { void }
   */
  resultReflection = () => {
    if ( this.errorCount > 0 ) {
      this.target.classList.add( this.className + '--error' );
    } else {
      this.target.classList.remove( this.className + '--error' );
    }
  }

  /**
   * バリデーション実行
   * @returns { void }
   */
  validateRun = () => {};

  /**
   * バリデーションを無効にする
   */
  invalidValidation = () =>
  {
    this.initError();
    this.target.value = '';
    this.target.classList.add( 'is--invalidValidation' );
  }

  /**
   * バリデーションを有効にする
   */
  validityValidation = () =>
  {
    this.initError();
    this.target.value = this.value;
    this.target.classList.remove( 'is--invalidValidation' );
  }
}
